export class GetWorkTypesRequest {
    lob: string = 'OL';
    customerID: string|number = 0;
    turnInSiteType: string = 'H';
    onlyDefault: string = 'true';
    AcvOrgId: string|number = 0;
}
